import { render, staticRenderFns } from "./TableWs.vue?vue&type=template&id=4c167bf6&scoped=true"
import script from "./TableWs.vue?vue&type=script&lang=js"
export * from "./TableWs.vue?vue&type=script&lang=js"
import style0 from "./TableWs.vue?vue&type=style&index=0&id=4c167bf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../wscpet/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c167bf6",
  null
  
)

export default component.exports